import React from 'react';
import { ThemeProvider } from "@material-ui/styles";
import { AuthProvider, AlertProvider, MachineProvider, SidebarProvider, OrderViewProvider, RegionProvider } from '../providers';
import AuthCheck from '../components/auth/AuthCheck';
import RegionLandingGuard from '../components/auth/RegionLandingGuard';
import ApiProvider from '../providers/ApiProvider';
import { RegionSettingsProvider } from '../providers/RegionSettingsProvider';
import { MysteryTeamProvider } from '../providers/MysteryTeamProvider';
import AppRouting from './AppRouting';
import { theme } from '../theme';
import { Layout } from '../components';

const App: React.FC = () => (
  <ThemeProvider theme={theme}>
    <AuthProvider>
      <ApiProvider>
        <AuthCheck>
          <RegionLandingGuard>
            <RegionProvider>
              <RegionSettingsProvider>
                <MysteryTeamProvider>
                  <AlertProvider>
                    <MachineProvider>
                      <SidebarProvider>
                        <OrderViewProvider>
                          <Layout>
                            <AppRouting />
                          </Layout>
                        </OrderViewProvider>
                      </SidebarProvider>
                    </MachineProvider>
                  </AlertProvider>
                </MysteryTeamProvider>
              </RegionSettingsProvider>
            </RegionProvider>
          </RegionLandingGuard>
        </AuthCheck>
      </ApiProvider>
    </AuthProvider>
  </ThemeProvider>
);

export default App;
